import React from 'react';
import { InvitationListPage } from './list';

export const InvitationsModule = () => {
  return <InvitationListPage />;
};
